interface IOptions {
  ms?: boolean;
}

const timestampToDateString = (timestamp, options?: IOptions) => {
  const { ms } = options || {};

  return new Date(ms ? timestamp : timestamp * 1000).toISOString();
};

export default timestampToDateString;
